import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CacheService {
  private persistent = localStorage;

  clearCache() {
    this.persistent.clear();
  }

  loadData<T>(key: string): T | null {
    const json = this.persistent.getItem(key);
    if (json) {
      return JSON.parse(json) as T;
    }
    return null;
  }

  storeData<T>(key: string, data: T): void {
    const json = JSON.stringify(data);
    this.persistent.setItem(key, json);
  }

  removeData(key: string): void {
    this.persistent.removeItem(key);
  }
}
